import { Box, Card, Button } from '@mui/material';
import LayoutAccessManagement from 'components/structure/LayoutAccessManagement';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Delegation from "assets/delegation.svg";
import UserFunctionalityService from 'services/UserFunctionalityService';
import { SnackbarContext } from 'context/snackBarContext';
import { AuthData } from "auth/AuthWarpper";
import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import EditIcon from "assets/EditIcon.svg";
import RoleService from 'services/RoleService';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CustomPagination from "components/pages/Import/Common/CustomPagination";

const StyledTableCell = styled(TableCell)(({ theme, width }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#0A3575",
        color: theme.palette.common.white,
        height: "52px",
        fontSize: "16px",
        fontWeight: 600,
        width: width || 'auto',
        minWidth: width || 'auto',
        maxWidth: width || 'none',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: "16px",
        height: "auto",
        minHeight: "100px",
        color: "#191E31",
        fontWeight: 600,
        width: width || 'auto',
        minWidth: width || 'auto',
        maxWidth: width || 'none',
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        overflowWrap: 'break-word',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: "#ffffff",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

const RoleAssignList = () => {
    const navigate = useNavigate();
    const { user } = AuthData();
    const { setOpenAlert, setSeverity, setMessage } = useContext(SnackbarContext);
    const [data, setdata] = useState([]);
    const [fetched, setFetched] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [tempNavigationState, setTempNavigationState] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [totalItems, setTotalItems] = useState(0);

    const columns = [
        { label: "Role Name", field: "role_name", align: "left", width: "15vw" },
        { label: "Country", field: "countryName", align: "left", width: "15vw" },
        { label: "Assigned Functionality", field: "roleFunctionality", align: "left" },
        { label: "Status", field: "status", align: "left", width: "120px" },
        { label: "Action", field: "action", align: "center", width: "120px" },
    ];

    const CallListAPI = async (page = 0, pageSize = itemsPerPage) => {
        try {
            let id = user?.userId;
            const response = await UserFunctionalityService.FetchUserFunctionalityList(id, page, pageSize);
            setdata(response?.data?.response?.profileFunctionality || []);
            setTotalItems(response?.data?.response?.totalItems || 0);
            setCurrentPage(page);
            setFetched(true);
        } catch (error) {
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
            setdata([]);
            setFetched(true);
            console.log(error);
        }
    };

    const paginate = (pageNumber, itemsPerPage) => {
        CallListAPI(pageNumber - 1, itemsPerPage);
    };

    if (user && !fetched) {
        CallListAPI(0, itemsPerPage);
    }

    const getStatusColor = (status) => {
        switch (status) {
            case 'Complete':
                return '#50AF47';
            case 'Pending':
                return '#EF7D00';
            default:
                return 'black';
        }
    };

    const handlenavigate = async (path, state) => {
        try {
            if (state?.rowData?.status == "Pending"  && (state?.rowData?.functionalities == null || state?.rowData?.functionalities.length === 0)) {
                const response = await RoleService.checkRoleCopyFlag(state?.rowData?.role_name);
                if (response?.data?.response === true) {
                    setTempNavigationState({ path, state });
                    setOpenModal(true);
                } else {
                    navigate(path, { state });
                }
            } else {
                navigate(path, { state });
            }
        } catch (error) {
            console.error("Error checking role copy flag:", error);
            navigate(path, { state });
            setSeverity("error");
            setMessage(error?.response?.data?.message || "Error checking role status");
            setOpenAlert(true);
        }
    }

    const handleNo = () => {
        navigate(tempNavigationState.path, { state: tempNavigationState.state });
        setOpenModal(false);
    }

    const handleYes = () => {
        setOpenModal(false);
        navigate('/countrySelection', { 
            state: { 
                ...tempNavigationState.state,
                fromConfirmation: true,
                roleName: tempNavigationState?.state?.rowData?.role_name,
                roleId: tempNavigationState?.state?.rowData?.role_id
            } 
        });
    }
    
    return (
        <LayoutAccessManagement title="Access Management">
            <Box sx={{ paddingBottom: "75px" }}>
            <Card
                sx={{
                    backgroundColor: "#f3f5f8",
                    color: "white",
                    marginBottom: "5px",
                    padding: "30px",
                    border: "none",
                    boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
                    display: "flex",
                    justifyContent: "center"
                }}
            >
                <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: '20px' }}>
                        <Button
                            sx={{
                                pt: '6px',
                                pr: '15px',
                                pb: '6px',
                                pl: '15px',
                                background: '#ffffff',
                                boxShadow: "0px 1.478px 2.957px 0px rgba(0, 0, 0, 0.16)",
                                color: "#0A3575",
                                fontWeight: 500,
                                borderRadius: "11px",
                                border: '0.739px solid #FFF',
                                color: '#0A3575',
                                fontSize: '20.696px',
                                fontFamily: 'Montserrat',
                                textTransform: 'capitalize',
                                fontWeight: '500',
                                display: "flex",
                                maxWidth: "187px",
                            }}
                            startIcon={<img src={Delegation} alt="delegation" />}
                            onClick={() => navigate('/selfDelegationList', { state: { fromUrl: "RoleAssignList" } })}
                        >
                            Delegation
                        </Button>
                    </Box>
                    <Box sx={{ width: "100%", marginTop: "40px", marginBottom: "40px", borderRadius: '16px', backgroundColor: "#fff", height: "auto" }}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700, tableLayout: 'fixed' }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        {columns?.map((column, index) => (
                                            <StyledTableCell 
                                                key={index} 
                                                align={column.align || "left"}
                                                width={column.width}
                                                sx={{ width: column.width }}
                                            >
                                                {column.label}
                                            </StyledTableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.map((row, rowIndex) => (
                                        <StyledTableRow key={rowIndex}>
                                            {columns?.map((column, colIndex) => (
                                                <StyledTableCell
                                                    key={colIndex}
                                                    align={column.align || "left"}
                                                    width={column.width}
                                                    sx={{ width: column.width }}
                                                >
                                                    {column.field === "action" ? (
                                                        <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                                                            {(row?.status !== "Pending") ?
                                                                <img
                                                                    style={{ cursor: "pointer", opacity: 0.3 }}
                                                                    className={row[column.field]}
                                                                    src={EditIcon}
                                                                    alt="Edit"
                                                                />
                                                                : 
                                                            <img
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() =>
                                                                    (row?.status == "Complete" || row?.status == "Completed") ? "" : handlenavigate(`${'/RoleEdit'}`, { rowData: row, fromUrl: "/RoleAssignList" })
                                                                }
                                                                src={EditIcon}
                                                                alt="Edit"
                                                            />
                                                            }
                                                        </Box>
                                                    ) : (
                                                        <>
                                                            {column.field === "roleFunctionality" ? (
                                                                <div>
                                                                    {row?.functionalities?.map((ele) => ele?.functionality_name).join(', ')}
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {column.field === "status" ? (
                                                                        <div style={{ color: getStatusColor(row[column.field]) }}>
                                                                            {row[column.field]}
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            {row[column.field]}
                                                                        </>
                                                                    )}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </StyledTableCell>
                                            ))}
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        
                    </Box>
                </Box>
              
            </Card>
            <Dialog
                open={openModal}
                onClose={() => setOpenModal(false)}
                PaperProps={{
                    style: {
                        borderRadius: '16px',
                        padding: '20px',
                        maxWidth: '450px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle sx={{ 
                    textAlign: 'center', 
                    color: '#fff',
                    fontSize: '16px',
                    fontWeight: '600',
                    backgroundColor: '#102A62',
                    borderRadius: '8px 8px 0px 0px',
                    margin: '-20px -20px 20px -20px',
                    padding: '16px'
                }}>
                    Confirmation
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', mt: 2 }}>
                    Do you want to copy functionality assigned
                    <br />to other countries for same role
                </DialogContent>
                <DialogActions sx={{ 
                    justifyContent: 'center', 
                    gap: 2,
                    mb: 2 
                }}>
                    <Button
                        onClick={handleNo}
                        sx={{
                            backgroundColor: '#737D86',
                            color: 'white',
                            borderRadius: '8px',
                            px: 4,
                            '&:hover': {
                                backgroundColor: '#737D86',
                            }
                        }}
                    >
                        NO
                    </Button>
                    <Button
                        onClick={handleYes}
                        sx={{
                            backgroundColor: '#102A62',
                            color: 'white',
                            borderRadius: '8px',
                            px: 4,
                            '&:hover': {
                                backgroundColor: '#102A62',
                            }
                        }}
                    >
                        YES
                    </Button>
                </DialogActions>
            </Dialog>
              {data?.length > 0 && (
                            <Box sx={{ position: "absolute", width: "calc(100% - 1px)" , marginLeft: "-24px", bottom: 0, backgroundColor:"#f3f5f8" }}>
                                <CustomPagination
                                    itemsPerPage={itemsPerPage}
                                    setItemsPerPage={(v) => setItemsPerPage(v)}
                                    totalItems={totalItems}
                                    paginate={paginate}
                                    currentPage={currentPage}
                                />
                            </Box>
                        )}
            </Box>
            
        </LayoutAccessManagement >
    );
}

export default RoleAssignList;
